import React, { ComponentType, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import * as paths from 'paths';
import * as LayoutComponents from './Components';
import * as PublicLayoutComponents from '../public/Components';

interface IMainRoute {
  layoutPaths: string[];
  component: ComponentType;
}

const useStyles = makeStyles(theme => ({
  '@global': {
    '.str-chat *, .str-chat *::after, .str-chat *::before': {
      fontFamily: theme.typography.fontFamily,
    },
    '.str-chat.messaging': {
      backgroundColor: 'transparent',
    },
    '.str-chat__avatar--rounded': {
      marginRight: 0,
      borderRadius: 4,
    },
    '.str-chat__input-flat': {
      padding: `${theme.spacing()}px ${theme.spacing(2)}px`,
    },
    '.str-chat__input-flat-emojiselect': {
      top: `calc(100% - ${theme.spacing(6)}px)`,
      left: theme.spacing(2),
    },
    '.str-chat__input-flat .str-chat__textarea > textarea': {
      paddingLeft: theme.spacing(7),
      paddingRight: theme.spacing(7),
    },
    '.str-chat__modal': {
      opacity: 1,
      background: 'rgba(0,0,0,0.5)',
    },
    '.str-chat__modal .str-chat__input-emojiselect': {
      height: 14,
      marginRight: theme.spacing(),
    },
    '.str-chat__modal .str-chat__input-emojiselect, .str-chat__modal .str-chat__input-fileupload': {
      top: 4,
    },
    '.react-images__blanket': {
      backgroundColor: 'rgba(0, 0, 0, 0.5) !important',
      zIndex: `${theme.zIndex.modal + 1} !important`,
    },
    '.react-images__positioner': {
      zIndex: `${theme.zIndex.modal + 2} !important`,
    },
    '.str-chat__loading-channels': {
      background: 'transparent',
    },
    '.str-chat__load-more-button': {
      marginTop: theme.spacing(),
    },
    '.str-chat__input-flat .str-chat__textarea > textarea:focus': {
      boxShadow: `0 0 0 3px ${theme.palette.primary.main}`,
    },
  },
}));

export const MainWrapper: ComponentType = ({ children }) => {
  useStyles();

  return <Fragment>{children}</Fragment>;
};

export const mainRoutes: IMainRoute[] = [
  { layoutPaths: [paths.index], component: LayoutComponents.TimelineLayout },
  { layoutPaths: [paths.adminPosts], component: LayoutComponents.AllPostsLayout },
  { layoutPaths: [paths.account], component: LayoutComponents.AccountLayout },
  { layoutPaths: [paths.activity], component: LayoutComponents.ActivityLayout },
  { layoutPaths: [paths.connectionSuccess], component: LayoutComponents.ConnectionsSuccess },
  { layoutPaths: [paths.connectionFailure], component: LayoutComponents.ConnectionsFailure },
  {
    layoutPaths: [paths.content, paths.contentLike, paths.contentComment],
    component: LayoutComponents.ContentPermalinkLayout,
  },
  {
    layoutPaths: [paths.contentShare],
    component: LayoutComponents.ContentShareLayout,
  },
  { layoutPaths: [paths.groupCreate], component: LayoutComponents.NewGroupLayout },
  { layoutPaths: [paths.search], component: LayoutComponents.SearchLayout },
  { layoutPaths: [paths.groupEdit], component: LayoutComponents.EditGroupLayout },
  { layoutPaths: [paths.notifications], component: LayoutComponents.NotificationsLayout },
  {
    layoutPaths: [paths.leaderboard, paths.leaderboardView],
    component: LayoutComponents.LeaderboardLayout,
  },
  {
    layoutPaths: [
      paths.group,
      paths.groupMembers,
      paths.groupApproval,
      paths.groupScheduled,
      paths.groupRemoved,
    ],
    component: LayoutComponents.GroupLayout,
  },
  {
    layoutPaths: [
      paths.profile,
      paths.profileGroups,
      paths.profileFollowing,
      paths.profileFollowers,
    ],
    component: LayoutComponents.ProfileLayout,
  },
  {
    layoutPaths: [
      paths.groups,
      paths.groupsDepartment,
      paths.groupsLocation,
      paths.groupsModerating,
      paths.groupsIOwn,
      paths.groupsFollowing,
      paths.groupsAll,
    ],
    component: LayoutComponents.GroupsIndexLayout,
  },
  {
    layoutPaths: [
      paths.people,
      paths.peopleFollowing,
      paths.peopleEveryone,
      paths.peopleDepartment,
      paths.peopleLocation,
    ],
    component: LayoutComponents.PeopleLayout,
  },
  {
    layoutPaths: [
      paths.adminAnalytics,
      paths.adminAnalyticsOverview,
      paths.adminAnalyticsGroups,
      paths.adminAnalyticsUsers,
      paths.adminAnalyticsPosts,
      paths.adminAnalyticsShares,
      paths.adminAnalyticsLeaderboards,
      paths.adminPeople,
      paths.adminPeopleInvite,
      paths.adminGroups,
      paths.adminInvitations,
      paths.adminMessages,
      paths.adminLeaderboards,
      paths.adminContentEmails,
      paths.adminContentEmailCreate,
      paths.adminContentEmailEdit,
      paths.adminSettingsDepartments,
      paths.adminSettingsLocations,
      paths.adminSettingsDisclosures,
      paths.adminSettingsPolicies,
      paths.adminSettingsReferrals,
      paths.adminSettingsCompanyOnboarding,
      paths.adminSettingsCustomOnboarding,
      paths.adminSettingsShareTracking,
      paths.adminSettingsUserSegments,
      paths.adminSettingsSharing,
      paths.adminSettingsStickers,
    ],
    component: LayoutComponents.AdminLayout,
  },
  {
    layoutPaths: [paths.socialMediaPolicy],
    component: PublicLayoutComponents.SocialMediaPolicyLayout,
  },
  {
    layoutPaths: [paths.postCreate, paths.postEdit],
    component: LayoutComponents.PostLayout,
  },
  {
    layoutPaths: [paths.share],
    component: LayoutComponents.ExternalShareLayout,
  },
];
